import { useEffect, useRef } from 'react';

import { useTrackAgentPanelMinimized } from '@air/analytics';

import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';

/**
 * Fires `agent_panel_minimized` once per user collapse. Covers Minimize, Tasks-toggle
 * while on tasks, and browser Back — all set `dock: 'minimized'` without necessarily calling
 * `minimize()`.
 */
export const useWorkspaceAgentPanelMinimizedAnalytics = () => {
  const dock = useWorkspaceAgentPanelStore((state) => state.dock);
  const { trackAgentPanelMinimized } = useTrackAgentPanelMinimized();
  const prevDockRef = useRef(dock);

  useEffect(() => {
    const wasMinimized = prevDockRef.current === 'minimized';
    prevDockRef.current = dock;

    if (dock === 'minimized' && !wasMinimized) {
      trackAgentPanelMinimized();
    }
  }, [dock, trackAgentPanelMinimized]);
};
